import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pc-tokendetail inner-box" }
const _hoisted_2 = { class: "token-tx-record table-shadow" }
const _hoisted_3 = { class: "head flex-between" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "bottom-page flex-right" }

import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import TokenInfos from "./TokenInfos.vue";
import TokenTxTable from "./TokenTxTable.vue";
import useTokenDetail from "@/mixins/useTokenDetail";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenDetail',
  setup(__props) {

const {
    tab,
    searchAddress,
    propsAdr,
    tokenName,
    TokenInfo,
    detailLoading,
    txLoading,
    pages,
    Trades,
    searchAdr,
    tabChange,
    pageChange,
    sizeChange,
    clearAddrFilter,
} = useTokenDetail();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Bread, {
      backTitle: "Token (ERC-20)",
      backRouter: "/token",
      secTitle: "Token 详情"
    }),
    _createVNode(TokenInfos, {
      infos: _unref(TokenInfo),
      loading: _unref(detailLoading)
    }, null, 8, ["infos", "loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass({ 'active-tab': _unref(tab) === 0 }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(tabChange)(0)))
          }, "交易记录", 2)
        ])
      ]),
      (_unref(tab) === 0)
        ? (_openBlock(), _createBlock(TokenTxTable, {
            key: 0,
            addr: _unref(propsAdr),
            token: _unref(tokenName),
            trades: _unref(Trades),
            loading: _unref(txLoading),
            pages: _unref(pages),
            onClear: _unref(clearAddrFilter)
          }, null, 8, ["addr", "token", "trades", "loading", "pages", "onClear"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(PageContainer, {
        onPageChange: _unref(pageChange),
        onSizeChange: _unref(sizeChange),
        currentPage: _unref(pages).currentPage,
        pageSize: _unref(pages).pageSize,
        total: _unref(pages).total
      }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"])
    ])
  ]))
}
}

})